module.exports = __webpack_public_path__ + "static/media/thanks.2c464398.png";